export default __webpack_public_path__ + "static/media/wegovy-needle-box-and-paper-off.3b8388bb.mp4";